// extracted by mini-css-extract-plugin
module.exports = {"content":"content-o5WAg","text":"text-38zKS","button":"button-dnXCl","button_cancel":"button_cancel-3D3ns"};